export const knownSkippyUrls = {
  homepage: '/',
  sac: '/sponsor-a-child',
  childBio: '/sponsor-a-child/child-bio',
  childBioNotFound: '/sponsor-a-child/404-gotten',
  blog: '/blog',
  crisisUpdates: '/crisis-updates',
  partner: '/partner',
  pressReleases: '/press-releases',
  search: '/search',
  give: '/give',
};

export const absoluteUrlFromPath = (path: string) => {
  return `${process.env.NEXT_PUBLIC_BASE_URL_DOTCOM}${path}`;
};
